export const ActionButton = ({
  children,
  ref,
  onMouseDown,
  focused,
  disabled,
}: {
  children: React.ReactNode;
  ref?: React.Ref<HTMLButtonElement>;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  focused?: boolean;
  disabled?: boolean;
}) => {
  return (
    <button
      ref={ref}
      className={`border border-primary-300 ${focused ? "bg-blue-50" : "bg-primary-25"} 
      shadow-sm rounded-[8px] text-blue-500 size-[24px] p-0
      hover:bg-blue-50 disabled:bg-white disabled:border-neutral-200 disabled:text-neutral-200
      flex items-center justify-center
        `}
      onMouseDown={onMouseDown}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
